import { useQuery, WatchQueryFetchPolicy } from '@apollo/client'
import { GET_LOGGED_IN_USER, GetLoggedInUserQuery } from '@dai/graphql'
import { auth } from 'api/Firebase'

const useLoggedInUser = (
  fetchPolicy: WatchQueryFetchPolicy = 'cache-and-network',
) => {
  const { data, loading, error } = useQuery<GetLoggedInUserQuery>(
    GET_LOGGED_IN_USER,
    {
      fetchPolicy, // TODO: clear cache on sign out might be better
    },
  )
  const handleLogout = async () => {
    await auth.signOut()
    window.location.replace('/auth/sign-in')
  }
  return { user: data?.loggedInUser, loading, error, handleLogout }
}

export default useLoggedInUser
